import React ,{useState, useEffect} from 'react'
import {useNavigate} from "react-router-dom"


const SetNewPassword = (props) => {
    let url = new URL(window.location);
    let userId = url.searchParams.get("userId");
    let passToken = Number(url.searchParams.get("passToken"));
    const [userName, setUserName] = useState(null)
    const host = "https://noteboss-backend.onrender.com";
    let navigate = useNavigate();
    const checkResetLink = async()=>{
        const url = `${host}/api/auth/getuserbyid`;
        const response = await fetch(url, {
          headers: {
            "content-type":
              "application/json"
          },
          method: "POST",
          body: JSON.stringify({userId: userId}),
        });
  
        let data = await response.json();

        setUserName(data.user.name)
        

        if(data.success === false){
            props.showAlert("danger", "Error", "Some Internal Error Occured")
           return navigate("/auth/login")
        }
        if(data.error==="userIdMismatched" || data.user.otp!==passToken){
            props.showAlert("danger", "Error", "Reset Link Expired")
           return navigate("/auth/login")
        }

    }
  useEffect(() => {
    // Checking Reset Link 
    checkResetLink();

    setTimeout(()=>{
      props.completeLoading()
    },100)
    //eslint-disable-next-line
  }, [])

  document.title = props.title;
    const [changePassword, setChangePassword] = useState({newPassword: "", confirmNewPassword: ""})
    const onChange = (e)=>{
        setChangePassword({...changePassword, [e.target.name] : e.target.value})
    }
    const handleSubmit = async (e) => {
      e.preventDefault();
      const url = `${host}/api/auth/changepassword`;
        const response = await fetch(url, {
          headers: {
            "content-type":
              "application/json"
          },
          method: "POST",
          body: JSON.stringify({userId:userId, newPassword: changePassword.newPassword}),
        });
  
        let data = await response.json();
        if(data.success===true){
            props.showAlert('success', "Success", "Password Reset Successfully")
            navigate("/auth/login")
        }
    };
  return (
    <>
    <div className={`container mt-4 mb-3 d-flex flex-column justify-content-center align-items-center ${props.theme === "dark" ? "text-light" : ""}`}>
        <h2>Recover Account | <span className="text-danger">NoteBoss</span></h2>
        <span className="fs-6 mb-1 text-secondary">Welcome Back, {userName} </span>
        <span className="fs-6 mb-5 text-secondary">Reset Your Password</span>
        <form onSubmit={handleSubmit}>
          <div className="mb-4">
            <label htmlFor="newPassword" className="form-label">
              New Password
            </label>
            <input
              type="password"
              className={`form-control input-manual-style ${
                  props.theme === "dark" ? "bg-dark text-light" : ""
                }`}
              id="newPassword"
              name="newPassword"
              aria-describedby="emailHelp"
              onChange={onChange}
              value={changePassword.newPassword}
            />
          </div>
          <div className="mb-4">
            <label htmlFor="confirmNewPassword" className="form-label">
              Confirm New Password
            </label>
            <input
              type="password"
              className={`form-control input-manual-style ${
                  props.theme === "dark" ? "bg-dark text-light" : ""
                }`}
              id="confirmNewPassword"
              name="confirmNewPassword"
              aria-describedby="emailHelp"
              onChange={onChange}
              value={changePassword.confirmNewPassword}
            />
            {((changePassword.newPassword !== changePassword.confirmNewPassword)||(changePassword.newPassword)==="")&&(changePassword.confirmNewPassword!=="")?
            <span className='text-warning' style={{fontSize:"12px"}}> <i className="uil uil-exclamation-triangle"></i> Password Must be Same</span>
            :""}
          </div>
          <button type="submit" className="btn btn-large btn-primary" disabled={(changePassword.newPassword !== changePassword.confirmNewPassword)||(changePassword.newPassword)===""?true:false}>
            Change Password
          </button>
        </form>
      </div>
    </>
  )
}

export default SetNewPassword